import { Component,  Input } from '@angular/core';
import { CueProgram, DropdownOption, Program } from 'globals/store/programs.data';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from '../../components/wrapper.component';
import { programOptionsReselector, programPermissionsReselector, programsArray } from '../../store/reselectors/programs.reselector';
import { PublicCuesInfo, PublicNotesInfo } from 'globals/store/share.data';
import { ShareNotesService } from '../../services/share.notes.service';
import { loadLocal, sleepForMS, saveLocal } from '../../helpers/helpers';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { TopMenuComponent } from '../program/top.menu';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { EditCueColumnsComponent } from './edit-cue-columns.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { CueSheetComponent } from './cue-sheet.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'cue-sheets',
    template: `
<top-menu [showPrint]="true" [manualPrint]="true" (print)="print()"></top-menu>
<mobile-menu></mobile-menu>
<div class="cue-sheets">
  <div class="controls">
    <h5>SELECTED ROOM/LOCATION: </h5>
    <dropdown *ngIf="programOptions?.length" class="program-select" 
      [selections]="programOptions" 
      [selected]="programOptions | findById:selectedProgramId" 
      (select)="setProgramId($event.id); setNumbers()"
    ></dropdown> 
    <div style="flex:1;"></div>
    <edit-cue-columns *ngIf="!!selectedProgramId" [programId]="selectedProgramId"></edit-cue-columns>
    <action-button *ngIf="!readOnly"  [text]="readMode ? 'EDIT MODE' : 'VIEW MODE'" (click)="readMode = !readMode"></action-button>
  </div>

  <binary-share-toggle *ngIf="!!cueInfos && !!selectedProgramId"
    class="notes-top"
    [type]="'brief'"
    [shareType]="shareTypes.cues "
    [shareableFormat]="'oneLine'"
    [shareCode]="cueInfos[selectedProgramId]?.publishCode || ''"
    [hint]="'Note: The shareable webpage is dynamic and will always load the current run of show.'"
    [title]="'Run of show webpage'"
    [shareTitle]="'Your shareable webpage:'"
    [status]="cueInfos[selectedProgramId]?.status || 'Off'"
    (toggle)="toggleShare($event)"
  ></binary-share-toggle>

  <ng-container *ngIf="!!selectedProgramId && (programs | findById:selectedProgramId) as program">
    <ng-container *ngFor="let day of program.sessions; trackBy: trackByIndex; index as day_idx; first as first; last as day_last">
      <h3>{{ program | programDayDate:day.day }}</h3>
      <cue-sheet 
        *ngFor="let session of day.sessions | idsToItems:program.sessions_obj; trackBy:trackBySessionDescriptionHash.bind(this);"
        [session]="session"
        [program]="program"
        [number]="sessionNumbers[session.id] || 0"
        [forceReadOnly]="readOnly || readMode"
      ></cue-sheet>
    </ng-container>
  </ng-container>
</div>
<loader-pane-fragment [trace]="traceNames.viewCueSheets"></loader-pane-fragment>
`,
    styleUrls: ['./cue-sheets.scss', '../../page.scss'],
    styles: [` 
  binary-share-toggle { margin-top: 20px; }
`],
    standalone: true,
    imports: [CueSheetComponent, CommonModule, IdsToItemsPipe, ProgramDayDate, FindByIdPipe, BinaryShareToggle, LoaderPaneFragmentComponent, ActionButtonComponent, TopMenuComponent, DropdownComponent, MobileMenuComponent, EditCueColumnsComponent],
})
export class CueSheetsComponent extends Wrapper<CueSheetsComponent> {
  programOptions: DropdownOption[]
  programs: Program[] 
  selectedProgramId: string
  cueInfos: { [programId: string]: PublicCuesInfo }
  readMode: boolean = false
  readOnly: boolean
  sessionNumbers: Dictionary<number> = {}
  traceNames = traceNames

    
  constructor(private shareNotesService: ShareNotesService) {
    super()
    this.selectProp(programOptionsReselector, false, 'programOptions')
    this.subProp(this.store.select('shareables', 'cues'), 'cueInfos')
    
    this.selectCallback(programsArray, null, (programs: Program[]) => {
      this.programs = programs

      this.selectedProgramId = loadLocal(`cueSheetsProgram${this.eventService.eventId}`, null)
      if (!this.selectedProgramId || !programs.find(p => p.id === this.selectedProgramId)) this.selectedProgramId = programs[0]?.id

      this.setNumbers()

    })
    this.selectCallback(programPermissionsReselector, null, ( is_readonly: {is_readonly: false, is_program: true, is_logistics: false}) => {
      this.readOnly = is_readonly.is_readonly
    })
  }

  setProgramId(programId: string) {
    this.selectedProgramId = programId
    saveLocal(`cueSheetsProgram${this.eventService.eventId}`, programId)
  }

  setNumbers() {
    const program = this.programs.find(p => p.id === this.selectedProgramId)
    this.sessionNumbers = {}
    if (program) {
      let index = 1
      program.sessions.forEach(s => 
        s.sessions.map(sId => program.sessions_obj[sId]).filter(s => !!s).forEach(s => {
          this.sessionNumbers[s.id] = index
          index += 1
      }))
    }
  }

  async print() {
    const readMode = this.readMode
    this.readMode = true
    if (!readMode) await sleepForMS(50)
    this.uiService.print()
    this.readMode = readMode    
  }

  toggleShare(share: boolean) {
    const infoShareable = this.cueInfos[this.selectedProgramId]
    if (!infoShareable) this.shareNotesService.addNewSharedNotes(this.selectedProgramId, this.eventService.eventId, 'cues')
    else this.shareNotesService.changeNotesShareStatus({ ...infoShareable, status: share ? 'On' : 'Off' })
  }

  

}

